import { FormItemsGroup, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import { AddressCity } from './elements/AddressCity'
import { AddressCountry } from './elements/AddressCountry'
import { AddressPobox } from './elements/AddressPobox'
import { AddressStreet1 } from './elements/AddressStreet1'
import { AddressStreet2 } from './elements/AddressStreet2'
import { AddressInputFieldProps } from './types/addressInputFieldProps'

type AddressProps = AddressInputFieldProps

export const Address = ({ isDisabled = false }: AddressProps): ReactElement => {
  return (
    <FormItemsGroup rowSpacing={Spacing.S12}>
      <AddressStreet1 isDisabled={isDisabled} />
      <AddressStreet2 isDisabled={isDisabled} />
      <FormItemsGroup itemsInRow={4}>
        <AddressPobox isDisabled={isDisabled} />
        <AddressCity isDisabled={isDisabled} />
      </FormItemsGroup>
      <AddressCountry isDisabled={isDisabled} />
    </FormItemsGroup>
  )
}
